async function mapFormFields(request, fields) {
  const formData = await request.formData();
  let payload = {};
  fields.forEach((key) => {
    if (key.includes("_")) {
      const parts = key.split("_");
      if (typeof payload[parts[0]] === "undefined") {
        payload[parts[0]] = {};
      }
      payload[parts[0]][parts[1]] = formData.get(key);
    } else {
      payload[key] = formData.get(key);
    }
  });
  return payload;
}
export {
  mapFormFields as m
};
//# sourceMappingURL=mapFormFields.js.map
